import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage
import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '@/features/auth/authSlice';
import registerReducer from '@/features/register/registerSlice';
import userReducer from '@/features/user/userSlice';
import confirmReducer from '@/features/confirm/confirmSlice';
import forgotPasswordReducer from '@/features/forgotPassword/forgotPasswordSlice';
import mobileFixedBottomMenuSliceReducer from '@/features/uiStates/mobileFixedBottomMenuSlice';
import seguidoresSliceReducer from '@/features/seguidores/seguidoresSlice';
import empresaSliceReducer from '@/features/empresa/empresaSlice';
import crearEmpresaSliceReducer from '@/features/empresa/crearEmpresaSlice';
import activarEmpresaSliceReducer from '@/features/empresa/activarEmpresaSlice';
import embajadorSliceReducer from '@/features/embajador/embajadorSlice';
import activarEmbajadorSliceReducer from '@/features/embajador/activarEmbajador';
import referralLinkSliceReducer from '@/features/embajador/referralLinkSlice';
import eventoSliceReducer from '@/features/evento/eventoSlice';
import publicEventosSliceReducer from '@/features/publicEventos/publicEventosSlice';
import carritoSliceReducer from '@/features/carrito/carritoSlice';
import puertaSliceReducer from '@/features/puerta/puertaSlice';
import notificacionSliceReducer from '@/features/notificacion/notificacionSlice';
import suscripcionSliceReducer from '@/features/suscripcion/suscripcionSlice';
import invitacionSliceReducer from '@/features/invitacion/invitacionSlice';
import experienciasSliceReducer from '@/features/experiencias/experienciasSlice';
import eventosFavoritosSliceReducer from '@/features/eventosFavoritos/eventosFavoritosSlice';

// Configuración de persistencia
const authPersistConfig = {
  key: 'auth',
  storage,
};

// Combinar reducers (si tienes más)
const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  register: registerReducer,
  confirm: confirmReducer,
  forgotPassword: forgotPasswordReducer,
  user: userReducer,
  // UI States
  mobileFixedBottomMenu: mobileFixedBottomMenuSliceReducer,
  // Vistas: Perfil
  seguidores: seguidoresSliceReducer,
  // Empresa
  crearEmpresa: crearEmpresaSliceReducer,
  activarEmpresa: activarEmpresaSliceReducer,
  empresa: empresaSliceReducer,
  // Embajador
  embajador: embajadorSliceReducer,
  activarEmbajador: activarEmbajadorSliceReducer,
  referralLink: referralLinkSliceReducer,
  // Evento
  evento: eventoSliceReducer,
  publicEventos: publicEventosSliceReducer,
  // Puerta
  puerta: puertaSliceReducer,
  // Carrito
  carrito: carritoSliceReducer,
  // Notificaciones
  notificacion: notificacionSliceReducer,
  // Suscripción
  suscripcion: suscripcionSliceReducer,
  // Invitaciones
  invitacion: invitacionSliceReducer,
  // Experiencias
  experiencias: experienciasSliceReducer,
  // Favoritos
  eventosFavoritos: eventosFavoritosSliceReducer,
});

// Crear store SIN persistencia global
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
export default store;